<template>
  <server-log-table kind="eventLog" />
</template>

<script>
import ServerLogTable from '../LogPages/ServerLogTable.vue'

export default {
  components: { ServerLogTable },
}
</script>
